import axios from 'axios'
import router from '@/router';
import http from './http'


// 网络参数
switch( process.env.VUE_APP_ENV) {
    case 'dev': axios.defaults.baseURL = 'https://api.kilitest.com'; break;
    case 'testing': axios.defaults.baseURL = 'https://api.kilitest.com'; break;
    case 'production': axios.defaults.baseURL = 'https://api.kilimall.com'; break;
}

/**
 * axion 请求封装
 */
const service = axios.create({
  timeout: 10000 // 请求超时时间
})

// request 拦截器
service.interceptors.request.use(
    (config: any) => {
        const headers = config.headers
        if (headers['Content-Type'] === 'application/octet-stream;charset=utf-8') {
            return config.data
        }
        return config
    }, 
    (error: any) => {
        Promise.reject(error)
    }
)

// respone 拦截器
service.interceptors.response.use(
  (response: any) => {   
    if (response.data.code && response.data.code !== 0) {
      if (response.data.code !== 200) {
        // code !=200 , 错误处理
      } 
      return Promise.resolve(response.data)
    } else {
        return response.data
    }  
  },
  (error: any) => {
    let $sa = http.get_sa_obj()
    let api_url = error && error.response && error.response.request ? error.response.request.responseURL : '未知url'
    if($sa) $sa.track('request_api_errer', {
              platform_type: 'Wap',
              api_url: api_url,
              page_url: window.location.href,
              status: error && error.response && error.response.request ? error.response.status : ''
            });
    if (error && error.response) {
      switch (error.response.status) {
        case 401: 
          router.push('/login')
          return;
          break;
        default: return Promise.reject(error.response.data);
      }
  } else {
    return Promise.reject(error.response.data);
  }        
    return Promise.reject(error.response.data);
    return false;
    if (error && error.response) {
        switch (error.response.status) {
            case 400: error.message = '请求错误(400)'; break;
            case 401: error.message = '未授权,请登录(401)'; break;
            case 403: error.message = '拒绝访问(403)'; break;
            case 404: error.message = `请求地址出错: ${error.response.config.url}`; break;
            case 405: error.message = '请求方法未允许(405)'; break;
            case 408: error.message = '请求超时(408)'; break;
            case 500: error.message = '服务器内部错误(500)'; break;
            case 501: error.message = '服务未实现(501)'; break;
            case 502: error.message = '网络错误(502)'; break;
            case 503: error.message = '服务不可用(503)'; break;
            case 504: error.message = '网络超时(504)'; break;
            case 505: error.message = 'HTTP版本不受支持(505)'; break;
            default: error.message = `连接错误: ${error.message}`; 
        }
    } else {
        error.message = '连接到服务器失败，请联系管理员'
    }        
    
    return Promise.reject(error)
  }
)

export default service
